<template>
  <div class="grid-transfer-toolbar">
    <div class="actions">
      <div class="actions-left">
        <b-input v-model="searchModel"
                 class="search-teams-input-custom"
                 v-b-tooltip.hover.top="'Поиск доступен по названию команды, nick и MLBB_ID'"
                 placeholder="Поиск команды"/>
        <div class="teams-count">Количество команд в этапе: {{ teamsCount }}</div>
      </div>
      <div class="actions-right" v-if="canTransfer">
        <button class="transfer-toggle"
                :class="{ active: transferMode }"
                v-b-tooltip.hover.top="'Выбрать команды прямо в сетке и перенести их в следующий этап'"
                @click="$emit('update:transferMode', !transferMode)">
          <span class="transfer-toggle-icon">&#8644;</span>
          {{ transferMode ? 'Выйти из режима переноса' : 'Перенести команды' }}
        </button>
      </div>
    </div>

    <transition name="transfer-panel-fade">
      <div v-if="transferMode" class="transfer-panel">
        <div class="transfer-hint">
          <template v-if="loading">
            <b-spinner small variant="primary" />
            Загружаем команды этапа...
          </template>
          <template v-else>
            <span class="pulse-dot"></span>
            Кликайте по командам в сетке, чтобы добавить их к переносу.
            <kbd>Esc</kbd> — выйти из режима.
          </template>
        </div>
        <div class="quick-picks">
          <span class="quick-picks-label">Быстрый выбор:</span>
          <button type="button" @click="$emit('quick-pick', 'winners')">Победители</button>
          <button type="button" @click="$emit('quick-pick', 'losers')">Проигравшие</button>
          <button type="button" @click="$emit('quick-pick', 'finalists')">Финалисты</button>
          <button type="button"
                  class="danger"
                  :disabled="!selectedCount"
                  @click="$emit('clear')">
            Снять всё
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "GridTransferToolbar",
  props: {
    // поисковая строка по командам
    value: {
      type: String,
      default: ''
    },
    teamsCount: {
      type: [Number, String],
      default: null
    },
    transferMode: {
      type: Boolean,
      default: false
    },
    selectedCount: {
      type: Number,
      default: 0
    },
    canTransfer: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    searchModel: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  }
}
</script>

<style scoped lang="scss">
.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;

  @media screen and (max-width: 500px) {
    display: block;
  }

  .actions-left {
    display: flex;
    align-items: center;
    gap: 10px;

    @media screen and (max-width: 700px) {
      flex-wrap: wrap;
    }
  }

  .actions-right {
    display: flex;
    align-items: center;
    gap: 10px;

    @media screen and (max-width: 500px) {
      margin-top: 10px;
    }
  }

  .teams-count {
    background-color: white;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    border: 1px solid #ced4da;
    color: #707070;
    font-size: 13px;
    white-space: nowrap;

    @media screen and (max-width: 500px) {
      margin-top: 10px;
      width: fit-content;
    }
  }

  .search-teams-input-custom {
    font-size: 13px;
  }

  .transfer-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    border: 1px solid #7366ff;
    border-radius: 15px;
    padding: 8px 18px;
    background: #7366ff;
    color: white;
    font-size: 11px;
    font-weight: 600;
    transition: .2s;

    &:hover {
      background: #5f51ff;
      border-color: #5f51ff;
    }

    &.active {
      background: white;
      color: #7366ff;
      box-shadow: 0 0 0 3px rgba(115, 102, 255, .18);
    }

    .transfer-toggle-icon {
      font-size: 14px;
      line-height: 1;
    }
  }
}

.transfer-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  margin-bottom: 20px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #ded9ff;
  background: linear-gradient(90deg, #f6f4ff 0%, #fbfbfe 100%);

  .transfer-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #5c5c70;

    kbd {
      background: #ffffff;
      border: 1px solid #ded9ff;
      border-radius: 4px;
      padding: 1px 5px;
      color: #4d43b5;
      font-size: 10px;
      box-shadow: none;
    }
  }

  .pulse-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #7366ff;
    flex: 0 0 auto;
    animation: transfer-pulse 1.6s infinite;
  }

  .quick-picks {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;

    .quick-picks-label {
      font-size: 11px;
      color: #a5a5b5;
      margin-right: 2px;
    }

    button {
      border: 1px solid #ded9ff;
      border-radius: 50px;
      padding: 5px 12px;
      background: white;
      color: #4d43b5;
      font-size: 11px;
      font-weight: 600;
      transition: .2s;

      &:hover:not(:disabled) {
        background: #7366ff;
        border-color: #7366ff;
        color: white;
      }

      &:disabled {
        opacity: .5;
      }

      &.danger {
        color: #d13c3c;
        border-color: #ffd4d4;

        &:hover:not(:disabled) {
          background: #d13c3c;
          border-color: #d13c3c;
          color: white;
        }
      }
    }
  }
}

@keyframes transfer-pulse {
  0% { box-shadow: 0 0 0 0 rgba(115, 102, 255, .55); }
  70% { box-shadow: 0 0 0 7px rgba(115, 102, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(115, 102, 255, 0); }
}

.transfer-panel-fade-enter-active,
.transfer-panel-fade-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}

.transfer-panel-fade-enter,
.transfer-panel-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
